import appConfig from '../../configs/appConfig';
import userChannelNames from '../../consts/auth/userChannelNames';
import channelTypes from '../../consts/channelTypes';
import {selectUserChannel} from '../../state/selectors/auth';
import {setChannelType} from '../../state/slice/global';
import {dispatch, getState} from '../../state/store';

const setAppChannelType = () => {
    const isDashboardEnabled = appConfig.getIsDashboardEnabled();
    const userChannel = selectUserChannel(getState());

    const appChannel =
        isDashboardEnabled && userChannel === userChannelNames.COACH ? channelTypes.RETAIL : channelTypes.CONSUMER;

    dispatch(setChannelType(appChannel));
};

export default {
    setAppChannelType,
};
